export default __webpack_public_path__ + "static/media/Mark-2-HUD-Pop-Up (Target Info).03e84567.jpg";